/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_USER_PROFILE = '[Account] Update User Profile',
  GET_USER_PROFILE_SUCCESS = '[Account] User Profile Success',
  UPDATE_USER_PROFILE = '[Account] Update User Profile',
  UPDATE_USER_PROFILE_SUCCESS = '[Account] Update User Profile Success',
  COMPLETE_PROFILE = '[Account] Complete Profile',
  COMPLETE_PROFILE_SUCCESS = '[Account] Complete Profile Success',
  COMPLETE_PROFILE_FAILED = '[Account] Complete Profile Failed',
  GET_TRANSACTIONS = '[Account] Get Transactions',
  GET_TRANSACTIONS_SUCCESS = '[Account] Get Transactions Success',
  GET_TRANSACTIONS_FAILED = '[Account] Get Transactions Failed',
  EDIT_USER_PROFILE = '[Account] Edit User Profile',
  EDIT_USER_PROFILE_SUCCESS = '[Account] Edit User Profile Success',
  EDIT_USER_PROFILE_FAILED = '[Account] Edit User Profile Success',
  SCAN_QR = '[Account] Scan QR',
  SCAN_QR_SUCCESS = '[Account] Scan QR Success',
  SCAN_QR_FAILED = '[Account] Scan QR Failed',
  SEND_POINTS = '[Account] Send Points',
  SEND_POINTS_SUCCESS = '[Account] Send Points Success',
  SEND_POINTS_FAILED = '[Account] Send Points Failed',
  GET_USER_CONTACTS = '[Shared] Get User Contact',
  RELOAD_USER_CONTACTS = '[Shared] Reload User Contact',
  GET_USER_CONTACTS_SUCCESS = '[Shared] Get User Contact Success',
  CHANGE_PASSWORD = '[Auth] Change Password',
  CHANGE_PASSWORD_SUCCESS= '[Account] Change Password Success',
  CONFIRM_CHANGE_PASSWORD = '[Account] Confirm Change Password',
  CONFIRM_CHANGE_PASSWORD_SUCCESS = '[Account] Confirm Change Password Success',  
  DELETE_ACCOUNT = '[Account] Delete Account',
  DELETE_ACCOUNT_SUCCESS = '[Account] Delete Account Success',  

  SEMI_VERIFICATION_EMAIL= '[Account] Semi Verification',
  SEMI_VERIFICATION_EMAIL_SUCCESS= '[Account] Semi Verification success',
  SEMI_VERIFICATION_EMAIL_FAILED= '[Account] Semi Verification failed',
  CONFIRM_EMAIL= '[Account] Confirm email',
  CONFIRM_EMAIL_SUCCESS= '[Account] Confirm email success',
  CONFIRM_EMAIL_FAILED= '[Account] Confirm email failed',
  RESEND_OTP = '[Account] Resend OTP',
  RESEND_OTP_SUCCESS = '[Account] Resend OTP Success',
  RESEND_OTP_FAILED = '[Account] Resend OTP Failed',
}

export const getUserProfile = createAction(
  ActionTypes.GET_USER_PROFILE
);

export const getUserProfileSuccess = createAction(
  ActionTypes.GET_USER_PROFILE_SUCCESS,
  props<{ data: any }>()
);

export const updateUserProfile = createAction(
  ActionTypes.UPDATE_USER_PROFILE,
  props<{ data: any }>()
);

export const updateUserProfileSuccess = createAction(
  ActionTypes.UPDATE_USER_PROFILE_SUCCESS,
  props<{ data: any }>()
);

export const completeProfile = createAction(
  ActionTypes.COMPLETE_PROFILE,
  props<{ data: any }>()
);

export const completeProfileSuccess = createAction(
  ActionTypes.COMPLETE_PROFILE_SUCCESS,
  props<{ data: any }>()
);

export const completeProfileFailed = createAction(
  ActionTypes.COMPLETE_PROFILE_FAILED,
  props<{ data: any }>()
);

export const getTransaction = createAction(
  ActionTypes.GET_TRANSACTIONS,
  props<{ data: any }>()
);

export const getTransactionSuccess = createAction(
  ActionTypes.GET_TRANSACTIONS_SUCCESS,
  props<{ data: any }>()
);

export const getTransactionFailed = createAction(
  ActionTypes.GET_TRANSACTIONS_FAILED,
  props<{ data: any }>()
);

export const editProfile = createAction(
  ActionTypes.EDIT_USER_PROFILE,
  props<{ data: any }>()
);

export const editProfileSuccess = createAction(
  ActionTypes.EDIT_USER_PROFILE_SUCCESS,
  props<{ data: any }>()
);

export const editProfileFailed = createAction(
  ActionTypes.EDIT_USER_PROFILE_FAILED,
  props<{ data: any }>()
);

export const scanQr = createAction(
  ActionTypes.SCAN_QR,
  props<{ data: any, sendWith: any }>()
);

export const scanQrSuccess = createAction(
  ActionTypes.SCAN_QR_SUCCESS,
  props<{ data: any, sendWith: any }>()
);

export const scanQrFailed = createAction(
  ActionTypes.SCAN_QR_FAILED,
  props<{ data: any }>()
);

export const sendPoints = createAction(
  ActionTypes.SEND_POINTS,
  props<{ data: any}>()
);

export const sendPointsSuccess = createAction(
  ActionTypes.SEND_POINTS_SUCCESS,
  props<{ data: any, payload: any}>()
);

export const getUserContact = createAction(
  ActionTypes.RELOAD_USER_CONTACTS,
  props<{ data: any}>()
);

export const reloadUserContact = createAction(
  ActionTypes.RELOAD_USER_CONTACTS,
);

export const getUserContactSuccess = createAction(
  ActionTypes.GET_USER_CONTACTS_SUCCESS,
  props<{ data: any}>()
);

export const confirmChangePassword = createAction(
  ActionTypes.CONFIRM_CHANGE_PASSWORD,
  props<{ username: string}>()
);

export const confirmChangePasswordSuccess = createAction(
  ActionTypes.CONFIRM_CHANGE_PASSWORD_SUCCESS,
  props<{ data: any}>()
);

export const changePassword = createAction(
  ActionTypes.CHANGE_PASSWORD,
  props<{ data: any }>()
);

export const changePasswordSuccess = createAction(
  ActionTypes.CHANGE_PASSWORD_SUCCESS,
  props<{ data: any}>()
);

export const deleteAccount = createAction(
  ActionTypes.DELETE_ACCOUNT,
  props<{ data: any }>()
);

export const deleteAccountSuccess = createAction(
  ActionTypes.DELETE_ACCOUNT_SUCCESS,
  props<{ data: any}>()
);

export const semiVerificationEmail = createAction(
  ActionTypes.SEMI_VERIFICATION_EMAIL,
  props<{ data: any }>()
);

export const semiVerificationEmailSuccess = createAction(
  ActionTypes.SEMI_VERIFICATION_EMAIL_SUCCESS,
  props<{ data: any }>()
);

export const semiVerificationEmailFailed = createAction(
  ActionTypes.SEMI_VERIFICATION_EMAIL_FAILED,
  props<{ data: any }>()
);

export const confirmEmail = createAction(
  ActionTypes.CONFIRM_EMAIL,
  props<{ data: any }>()
);

export const confirmEmailSuccess = createAction(
  ActionTypes.CONFIRM_EMAIL_SUCCESS,
  props<{ data: any }>()
);

export const confirmEmailFailed = createAction(
  ActionTypes.CONFIRM_EMAIL_FAILED,
  props<{ data: any }>()
);

export const resendOtp = createAction(
  ActionTypes.RESEND_OTP,
  props<{ data: any; }>()
);

export const resendOtpSuccess = createAction(
  ActionTypes.RESEND_OTP_SUCCESS,
  props<{ data: any }>()
);

export const resendOtpFailed = createAction(
  ActionTypes.RESEND_OTP_FAILED,
  props<{ data: any }>()
);